import React, { useState } from "react";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete, {
  createFilterOptions,
} from "@mui/material/Autocomplete";
import { DateTime } from "luxon";
import {
  NotificationManager,
} from "react-notifications";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import addReferralProgram from "../../apis/adminReferralAPI/addReferralProgram";
import updateReferralProgram from "../../apis/adminReferralAPI/updateReferralProgram";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import DataTable from "../../components/DataTable/DataTable";
function AdminReferralKendo({ userType, userIdType, isDataLoaded, setisDataLoaded, allPublicSkill, allRecruitmentOrgs, allData, getData }) {

  const activityOptions = [
    { label: 'All', value: '' },
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' }
  ]

  const [modalIsOpen, setmodalIsOpen] = useState(false);
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);

  const [skillAndLocation, setSkillAndLocation] = useState([
    {
      skill: null,
      location: [],
    },
  ]);

  const [editData, setEditData] = useState([]);

  const [selectedOrg, setSelectedOrg] = useState(null);
  const [selectedIsActive, setSelectedIsActive] = useState(null);

  const [atvBtn, setAtvBtn] = useState(false);

  const countryList = [
    {
      currency: "USD",
      flag: "",
      isoCode: "US",
      latitude: "38.00000000",
      longitude: "-97.00000000",
      name: "United States",
      phonecode: "+1",
    },
    {
      currency: "CAD",
      flag: "",
      isoCode: "CA",
      latitude: "60.00000000",
      longitude: "-95.00000000",
      name: "Canada",
      phonecode: "+1",
    },
    {
      currency: "INR",
      flag: "",
      isoCode: "IN",
      latitude: "20.00000000",
      longitude: "77.00000000",
      name: "India",
      phonecode: "+91",
    }]

  const btnGreen = {
    color: "#fff",
    backgroundColor: "#1885e6",
    border: "none",
    padding: "7px 23px 7px 23px",
    position: "absolute",
    top: "20px",
    right: "93px",
  };

  const closeButton = {
    position: "absolute",
    right: "7px",
    top: "12px",
    color: "grey",
  };


  function isActiveFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.getValue(columnId);
    const filterValLower = filterValue.toLowerCase();
    if (filterValLower === 'true') return rowValue === true;
    if (filterValLower === 'false') return rowValue === false;
    return true;
  }

  const getIsActiveFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    const activityOptions = [
      { label: 'All', value: '' },
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' }
    ];
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
  }

  // Date filter function
  function dateFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true; // no filter
    const rowValue = row.original.createdAt;
    if (!rowValue) return false;

    try {
      const rowDate = new Date(rowValue);
      const filterDate = new Date(filterValue);

      // Reset time to start of day for both dates to compare only date part
      rowDate.setHours(0, 0, 0, 0);
      filterDate.setHours(0, 0, 0, 0);

      return rowDate.getTime() === filterDate.getTime();
    } catch (error) {
      console.warn('Date filtering error:', error);
      return false;
    }
  }

  const getDateFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    return filterValue ? new Date(filterValue) : null;
  }
  //

  const getFilteredCountryList = (index) => {
    let newList = countryList;
    for (let i = 0; i < skillAndLocation[index]?.location?.length; i++) {
      newList = newList.filter(
        (item) => item.name !== skillAndLocation[index]?.location[i]?.name
      );
    }

    return newList;
  };

  const openModal = (e, client) => {
    setmodalIsOpen(true);
  };

  const handelEditClick = (data) => {
    setEditModalIsOpen(true);
    setEditData(data);
    setSelectedOrg(data?.recruitmentpartner);
    setSelectedIsActive(data?.isActive);

    // filtering Skills and Locations

    let skillsArr = [];
    let locationsArr = [];
    for (let i = 0; i < data.referralskills.length; i++) {
      skillsArr.push(data?.referralskills[i].skill);
    }

    skillsArr = skillsArr.filter(
      (value, index, self) => index === self.findIndex((t) => t.id === value.id)
    );
    for (let i = 0; i < skillsArr.length; i++) {
      locationsArr[i] = [];
      for (let j = 0; j < data.referralskills.length; j++) {
        if (skillsArr[i].id === data.referralskills[j].skillId) {
          locationsArr[i][locationsArr[i].length] = JSON.parse(
            data.referralskills[j].location
          );
        }
      }
    }

    let skillnLocation = [];
    for (let i = 0; i < skillsArr.length; i++) {
      skillnLocation.push({
        skill: skillsArr[i],
        location: locationsArr[i],
      });
    }

    setSkillAndLocation(skillnLocation || []);
  };

  const addRow = () => {
    const row = {
      skill: null,
      location: [],
    };

    setSkillAndLocation([...skillAndLocation, row]);
  };

  const closeExtraRow = (i) => {
    let data = skillAndLocation.filter((item, index) => index !== i);

    setSkillAndLocation(data);
  };

  const closeModal = () => {
    setSelectedOrg(null);
    setSelectedIsActive(null);
    let row = {
      skill: null,
      location: [],
    };
    setSkillAndLocation([row]);

    setmodalIsOpen(false);
  };

  const closeEditModal = () => {
    setEditModalIsOpen(false);
    setSelectedOrg(null);
    setSelectedIsActive(null);
    let row = {
      skill: null,
      location: [],
    };
    setSkillAndLocation([row]);
  };

  const orgChangeHandler = (event, newValue) => {
    if (typeof newValue === "string") {
      setSelectedOrg({
        name: newValue,
      });
    } else if (newValue && newValue.inputValue) {
      // Create a new value from the user input
      setSelectedOrg({
        name: newValue.inputValue,
      });
    } else {
      setSelectedOrg(newValue);
    }
  };

  const skillChangeHandler = (event, newValue, i) => {
    let originalData = [...skillAndLocation];
    let dataToBeChange = originalData[i];
    dataToBeChange.skill = newValue;
    originalData[i] = dataToBeChange;
    setSkillAndLocation(originalData || []);
  };

  const locationChangeHandler = (newValue, i) => {
    let originalData = [...skillAndLocation];
    let dataToBeCHanged = originalData[i];
    dataToBeCHanged.location = newValue;
    originalData[i] = dataToBeCHanged;
    setSkillAndLocation(originalData || []);
  };

  const addReferralProgramFunc = async () => {
    setAtvBtn(true)
    let skillsArr = [];
    let flag = 0;
    for (let i = 0; i < skillAndLocation?.length; i++) {
      if (
        skillAndLocation[i]?.location?.length !== 0 &&
        skillAndLocation[i].skill !== null
      ) {
        for (let j = 0; j < skillAndLocation[i]?.location?.length; j++) {
          skillsArr.push({
            skillid: skillAndLocation[i].skill?.id,
            location: JSON.stringify(skillAndLocation[i]?.location[j]),
          });
        }
      } else {
        flag = 1;
      }
    }

    let agencyArr = [];

    for (
      let i = 0;
      i < selectedOrg?.agencyrecruitmentorganizations?.length;
      i++
    ) {
      agencyArr.push(
        '"' + selectedOrg?.agencyrecruitmentorganizations[i]?.id + '"'
      );
    }

    let payload = {
      recruitmentpartnerId: selectedOrg?.id,
      agencyId: agencyArr.length === 0 ? "[]" : `[${agencyArr}]`,
      createdBy: userIdType,
      updatedBy: userIdType,
      skills: skillsArr,
      isActive: selectedIsActive,
    };

    if (selectedOrg === null || selectedIsActive === null || flag === 1) {
      setAtvBtn(false)
      NotificationManager.error("Please select all the fields", "Error", 10000);
    } else {
      try {
        let response = await addReferralProgram(payload);
        if (response.status === 200) {
          setAtvBtn(false)
          NotificationManager.error(
            "This Recruitment organization already exists in Referral Program",
            "Error",
            10000
          );
        } else {
          closeModal();
          getData();
          setAtvBtn(false)
          NotificationManager.success(
            "Referral program created successfully",
            "Success",
            10000
          );
        }
      } catch (err) {
        console.log("Error", err);
        setAtvBtn(false)
      }
    }
  };

  const editReferralProgramFunc = async () => {
    setAtvBtn(true)
    let skillsArr = [];
    let flag = 0;
    for (let i = 0; i < skillAndLocation?.length; i++) {
      if (
        skillAndLocation[i]?.location?.length !== 0 &&
        skillAndLocation[i].skill !== null
      ) {
        for (let j = 0; j < skillAndLocation[i]?.location?.length; j++) {
          skillsArr.push({
            skillId: skillAndLocation[i].skill?.id,
            location: JSON.stringify(skillAndLocation[i]?.location[j]),
          });
        }
      } else {
        flag = 1;
      }
    }

    let agencyArr = [];

    for (
      let i = 0;
      i < selectedOrg?.agencyrecruitmentorganizations?.length;
      i++
    ) {
      agencyArr.push(
        '"' + selectedOrg?.agencyrecruitmentorganizations[i]?.id + '"'
      );
    }

    let payload = {
      referralpartnerId: editData.referralskills[0].referralpartnerId,
      recruitmentpartnerId: selectedOrg?.id,
      agencyId: agencyArr.length === 0 ? "[]" : `[${agencyArr}]`,
      updatedBy: userIdType,
      skills: skillsArr,
      isActive: selectedIsActive,
    };

    if (selectedOrg === null || selectedIsActive === null || flag === 1) {
      setAtvBtn(false)
      NotificationManager.error("Please select all the fields", "Error", 10000);
    } else {
      try {
        let response = await updateReferralProgram(payload);
        if (
          response.data?.message ===
          "This recruitmentpartner name already exists in referral Please use a different recruitmentpartner name"
        ) {
          setAtvBtn(false)
          NotificationManager.error(
            "This Recruitment organization already exists in Referral Program",
            "Error",
            10000
          );
        } else {
          closeEditModal();
          getData();
          setAtvBtn(false)
          NotificationManager.success(
            "Referral program updated successfully",
            "Success",
            10000
          );
        }
      } catch (err) {
        console.log("Error", err);
        setAtvBtn(false)
      }
    }
  };

  const filterOptions = createFilterOptions({
    matchFrom: "start",
    stringify: (option) => option.name,
  });

  const columns = [
    {
      header: "Actions",
      size: 80,
      enableSorting: false,
      enableColumnFilter: false,
      cell: ({ row }) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={() => handelEditClick(row.original)}
            variant="contained"
            color="primary"
          >
            Edit
          </Button>
        </div>
      ),
    },
    {
      accessorKey: "recruitmentpartner.name",
      header: "Recruitment Organization",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "skills",
      header: "Skills",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "locations",
      header: "Locations",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "createdAt",
      header: "Created At",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: dateFilterFn,
      Filter: ({ column }) => (
        <div className="date-picker-filter-container">
          <DatePicker
            selected={getDateFilterValue(column)}
            onChange={(date) => {
              column.setFilterValue(date ? date.toISOString() : '');
            }}
            dateFormat="MM/dd/yyyy"
            placeholderText="Select date"
            maxDate={new Date()}
            isClearable
            showIcon={true}
            className="date-picker-table-filter"
          />
        </div>
      ),
      cell: ({ row }) => (
        <>
          {DateTime.fromISO(row.original.createdAt)
            .toFormat("MM/dd/yyyy")
            .toString()}
        </>
      )
    },
    {
      accessorKey: "isActive",
      header: "Is Active",
      size: 80,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (getValue() ? "True" : "False"),
      Filter: ({ column }) => (
        <Autocomplete
          disableClearable
          className='isActiveFilter-autocomplete'
          options={activityOptions}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : '');
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
            />
          )}
          sx={{ width: '100%' }}
        />
      )
    },
  ]



  return (
    <>
      <Button
        variant="outlined"
        style={btnGreen}
        color="primary"
        onClick={openModal}
      >
        Add Referral Program
      </Button>
      <div className="containerMain adminReferralTable">
     
        <DataTable
          data={allData}
          columns={columns}
          isLoading={!isDataLoaded}
          initialColumnFilters={[
            {
              id: 'isActive',
              value: 'true'
            }
          ]}
        />




      </div>

      {/* Add Referral form */}
      <Dialog
        onClose={closeModal}
        aria-labelledby="customized-dialog-title"
        open={modalIsOpen}
        PaperProps={{
          style: {
            width: "600px",
          },
        }}
      >
        <div className="Recruiter_Private_Skill_Modal">
          <DialogTitle
            id="customized-dialog-title"
            className="admindailog_title_modal_adminReferral"
            onClose={closeModal}
          >
            Add Referral Program
            <IconButton
              aria-label="close"
              style={closeButton}
              onClick={closeModal}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        </div>
        <DialogContent>
          <div className="optionsStyle">
            <Typography gutterBottom>Recruitment Organization*</Typography>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                id="combo-box-demo"
                filterSelectedOptions
                options={allRecruitmentOrgs}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Recruitment Organization"
                  />
                )}
                onChange={(event, newValue) =>
                  orgChangeHandler(event, newValue)
                }
              />
            </FormControl>
          </div>

          <div className="skilLocationContainer">
            {skillAndLocation.map((item, i) => {
              return (
                <div key={i}>
                  <div className="optionsStyle df">
                    <div className="skillLocation">
                      <Typography gutterBottom>Skills*</Typography>
                      <FormControl fullWidth variant="outlined">
                        <Autocomplete
                          id="combo-box-demo"
                          filterSelectedOptions
                          value={item.skill || null}
                          options={allPublicSkill}
                          getOptionLabel={(option) => option.name}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select Skills"
                            />
                          )}
                          onChange={(event, newValue) =>
                            skillChangeHandler(event, newValue, i)
                          }
                        />
                      </FormControl>
                    </div>

                    <div className="skillLocation locationCss">
                      <Typography gutterBottom>Locations*</Typography>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        className="locationCloseBtnStyle"
                      >
                        <Autocomplete
                          multiple
                          id="combo-box-demo"
                          className="locationField"
                          value={skillAndLocation[i].location}
                          options={getFilteredCountryList(i)}
                          autoHighlight
                          filterOptions={filterOptions}
                          getOptionLabel={(option) => option.name}
                          onChange={(e, newValue) => {
                            locationChangeHandler(newValue, i);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              required={true}
                              placeholder="Select Locations"
                            />
                          )}
                        />
                        <div className="closeBtnStyle">
                          {i !== 0 && (
                            <CancelRoundedIcon
                              onClick={() => closeExtraRow(i)}
                            />
                          )}
                        </div>
                      </FormControl>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="optionsStyle addButton">
            <AddCircleIcon onClick={addRow} className="addBtn" />
          </div>
          <div className="optionsStyle">
            <Typography gutterBottom>Is Active*</Typography>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                id="combo-box-demo"
                filterSelectedOptions
                // options={getFilteredTests()}
                options={[{ testName: "True" }, { testName: "False" }]}
                getOptionLabel={(option) =>
                  option.testName ? option.testName : ""
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Status"
                  />
                )}
                onChange={(e, newValue) => {
                  newValue?.testName === "True"
                    ? setSelectedIsActive(true)
                    : newValue?.testName === "False"
                      ? setSelectedIsActive(false)
                      : setSelectedIsActive(null);
                }}
              />
            </FormControl>
          </div>
        </DialogContent>
        <Grid size={{ xs: 12, md: 12 }} className="user_pop_button">
          <DialogActions>
            <Button variant="outlined" className="btn3" color="primary" onClick={closeModal}>
              Cancel
            </Button>
            <button variant="outlined" className="btn3 btn_primary cp" disabled={atvBtn} onClick={addReferralProgramFunc}>
              <div className="btn_loader">
                Save
                &nbsp;
                {atvBtn &&
                  <div >
                    <CircularProgress size={13} />
                  </div>
                }
              </div>
            </button>

          </DialogActions>
        </Grid>
      </Dialog>

      {/* Edit Referral form */}
      <Dialog
        onClose={closeEditModal}
        aria-labelledby="customized-dialog-title"
        open={editModalIsOpen}
        PaperProps={{
          style: {
            width: "600px",
          },
        }}
      >
        <div className="Recruiter_Private_Skill_Modal">
          <DialogTitle
            id="customized-dialog-title"
            className="admindailog_title_modal_adminReferral"
            onClose={closeEditModal}
          >
            Edit Referral Program
            <IconButton
              aria-label="close"
              style={closeButton}
              onClick={closeEditModal}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        </div>
        <DialogContent>
          <div className="optionsStyle">
            <Typography gutterBottom>Recruitment Organization*</Typography>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                id="combo-box-demo"
                filterSelectedOptions
                value={selectedOrg}
                options={allRecruitmentOrgs}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Recruitment Organization"
                  />
                )}
                onChange={(event, newValue) =>
                  orgChangeHandler(event, newValue)
                }
              />
            </FormControl>
          </div>

          <div className="skilLocationContainer">
            {skillAndLocation.map((item, i) => {
              return (
                <div key={i}>
                  <div className="optionsStyle df">
                    <div className="skillLocation">
                      <Typography gutterBottom>Skills*</Typography>
                      <FormControl fullWidth variant="outlined">
                        <Autocomplete
                          id="combo-box-demo"
                          filterSelectedOptions
                          value={skillAndLocation[i].skill}
                          options={allPublicSkill}
                          getOptionLabel={(option) => option.name}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Select Skills"
                            />
                          )}
                          onChange={(event, newValue) =>
                            skillChangeHandler(event, newValue, i)
                          }
                        />
                      </FormControl>
                    </div>

                    <div className="skillLocation locationCss">
                      <Typography gutterBottom>Locations*</Typography>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        className="locationCloseBtnStyle"
                      >
                        <Autocomplete
                          multiple
                          id="combo-box-demo"
                          className="locationField"
                          value={skillAndLocation[i].location}
                          options={getFilteredCountryList(i)}
                          autoHighlight
                          filterOptions={filterOptions}
                          getOptionLabel={(option) => option.name}
                          onChange={(e, newValue) => {
                            locationChangeHandler(newValue, i);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              required={true}
                              placeholder="Select Locations"
                            />
                          )}
                        />
                        <div className="closeBtnStyle">
                          <CancelRoundedIcon onClick={() => closeExtraRow(i)} />
                        </div>
                      </FormControl>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="optionsStyle addButton">
            <AddCircleIcon onClick={addRow} className="addBtn" />
          </div>
          <div className="optionsStyle">
            <Typography gutterBottom>Is Active*</Typography>
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                id="combo-box-demo"
                filterSelectedOptions
                // options={getFilteredTests()}
                value={
                  selectedIsActive
                    ? { testName: "True" }
                    : { testName: "False" }
                }
                options={[{ testName: "True" }, { testName: "False" }]}
                getOptionLabel={(option) =>
                  option.testName ? option.testName : ""
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Status"
                  />
                )}
                onChange={(e, newValue) => {
                  newValue?.testName === "True"
                    ? setSelectedIsActive(true)
                    : newValue?.testName === "False"
                      ? setSelectedIsActive(false)
                      : setSelectedIsActive(null);
                }}
              />
            </FormControl>
          </div>
        </DialogContent>
        <Grid size={{ xs: 12, md: 12 }} className="user_pop_button">
          <DialogActions>
            <Button variant="outlined" className="btn3" color="primary" onClick={closeEditModal}>
              Cancel
            </Button>
            <button variant="outlined" className="btn3 btn_primary cp" disabled={atvBtn} onClick={editReferralProgramFunc}>
              <div className="btn_loader">
                Save
                &nbsp;
                {atvBtn &&
                  <div >
                    <CircularProgress size={13} />
                  </div>
                }
              </div>
            </button>
          </DialogActions>
        </Grid>
      </Dialog>
    </>
  );
}

export default AdminReferralKendo;
